import { CustomLayoutIconProps } from '@/components/custom-layout/types';
import { createZustandShallowStore } from '@/lib/zustand';
import { MenuResponse } from '@/server/api/v1/menu/menu.routes';
import { SetStoreState, storeStateResolver } from '@/types/use';

export interface SidebarItemProps {
    id?: string;
    name: string;
    href?: string;
    icon?: CustomLayoutIconProps;
    children?: SidebarItemProps[];
    className?: string;
    isActive?: boolean;
    isHidden?: boolean;
    isSystem?: boolean;
    key: string;
    description?: string;
    code?: string;
    numberOfParent?: number;
    appLanguageResourceCode?: string;
    appConfigurationIds?: string;
    _orginal?: MenuResponse;
    /**
     * Chỉ để sử dụng cho breadcrum
     * @default false
     */
    _showIcon?: boolean;
}

/**
 * Biến này gắn cứng 2 sidebar sẽ auto open
 */
const defaultSidebarOpen = {
    '20d10f66-0440-4736-87bf-5805d9bc1e10': true, // Danh sách công việc
    '40569c40-c67c-4fc4-9bb2-db0124f15522': true, // Trạng thái hồ sơ
};

/**
 * Một số sidebar sẽ bị ẩn đi nếu tài khoản đăng nhận là admin và không có nhân viên
 *
 *  */
export const sidebarRemoveWhenIsAdmin: Record<string, boolean> = {
    '20d10f66-0440-4736-87bf-5805d9bc1e10': true, // Danh sách công việc
    '40569c40-c67c-4fc4-9bb2-db0124f15522': true, // Trạng thái hồ sơsơ
};

export type SidebarStoreProps = {
    isShowSidebarIconOnly: boolean;
    setIsShowSidebarIconOnly: SetStoreState<boolean>;

    isShowMenuOverlay: boolean;
    setIsShowMenuOverlay: SetStoreState<boolean>;

    // mapped menus with keys
    menus: SidebarItemProps[];
    setMenus: SetStoreState<SidebarItemProps[]>;

    // active menu
    objActive: Record<string, boolean>;
    setObjActive: SetStoreState<Record<string, boolean>>;

    objCounter: Record<string, number>;
    setObjCounter: SetStoreState<Record<string, number>>;

    // menu array for search
    menuForSearch: SidebarItemProps[];
    setMenuForSearch: SetStoreState<SidebarItemProps[]>;

    // loading searchs
    isLoading: boolean;
    setIsLoading: SetStoreState<boolean>;

    showTotalBox: boolean;
    totalOnline?: number;
    totalAccess?: number;
    setTotalBox: SetStoreState<{
        showTotalBox: boolean;
        totalOnline?: number;
        totalAccess?: number;
    }>;
};

export const useSidebarStore = createZustandShallowStore<SidebarStoreProps>(
    (set, get) => {
        return {
            isShowSidebarIconOnly: false,
            setIsShowSidebarIconOnly(fn) {
                set((state) => ({
                    isShowSidebarIconOnly: storeStateResolver(
                        state.isShowSidebarIconOnly,
                        fn
                    ),
                }));
            },

            isShowMenuOverlay: false,
            setIsShowMenuOverlay(fn) {
                set((state) => ({
                    isShowMenuOverlay: storeStateResolver(
                        state.isShowMenuOverlay,
                        fn
                    ),
                }));
            },

            menus: [],
            setMenus(fn) {
                set((st) => ({
                    menus: storeStateResolver(st.menus, fn),
                }));
            },

            objActive: defaultSidebarOpen,
            setObjActive(fn) {
                set((state) => ({
                    objActive: storeStateResolver(state.objActive, fn),
                }));
            },
            objCounter: {},
            setObjCounter(fn) {
                set((state) => ({
                    objCounter: storeStateResolver(state.objCounter, fn),
                }));
            },

            isLoading: false,
            setIsLoading(fn) {
                set((state) => ({
                    isLoading: storeStateResolver(state.isLoading, fn),
                }));
            },
            menuForSearch: [],
            setMenuForSearch(fn) {
                set((state) => ({
                    menuForSearch: storeStateResolver(state.menuForSearch, fn),
                }));
            },
            showTotalBox: false,
            totalOnline: undefined,
            totalAccess: undefined,
            setTotalBox(fn) {
                set((state) =>
                    typeof fn === 'function'
                        ? fn({
                              showTotalBox: state.showTotalBox,
                              totalAccess: state.totalAccess,
                              totalOnline: state.totalOnline,
                          })
                        : fn
                );
            },
        };
    }
);
